import React from 'react';
import { Input, Control, ErrorComponent } from 'MWComponents';
import success_icon from '../img/success_icon.png';
import '../less';
import CountdownTimer from '../../SpecialOffers/GoodDeedsMC/components/CountDownTimer/timer';

export default function template() {
    const model = this.getModel(),
        { contactPhoneNumber, passwordOTP} = model.fields,
        { loanSum, loanTerm } = this.props,
        repeatOTP = this.state.repeatOTPbutton,
        termsData = {
          6: 'CALCULATOR_FULL_MONTHS',
          12: 'CALCULATOR_FULL_MONTHS',
          24: 'CALCULATOR_FULL_MONTHS_01',
          36: 'CALCULATOR_FULL_MONTHS',
          60: 'CALCULATOR_FULL_MONTHS',
        },

        form = (<React.Fragment>
              <div className="left-side">
                <div className="left-side">
                  <div className="title">{this.l10n('QUICK_CASH_WANT_TO_ORDER')}</div>
                  <div className="sub-title">{this.l10n('QUICK_CASH_WANT_TO_ORDER_SUBTITLE')}</div>
                    {loanSum && loanTerm && (
                      <React.Fragment>
                        <div className="terms">{this.l10n('QUICK_CASH_WANT_TO_ORDER_SUM')}<div className="numbers">{loanSum.toLocaleString('RU-ru') + ' ' + this.l10n('UAH_ICON')}</div> </div>
                        <div className="terms">{this.l10n('QUICK_CASH_WANT_TO_ORDER_TERM')}<div className="numbers">{loanTerm} {this.l10n(termsData[loanTerm])}</div></div>
                      </React.Fragment>
                    )}
                  <div className="card-order" style={(!loanSum && !loanTerm) ? { marginTop: '0px' } : {}}>
                    <div className="order-wrapper green-card">
                      <Control>
                        <Input
                          {...this.bindProps('phone')}
                          name="contactPhoneNumber"
                          value={contactPhoneNumber.value}
                          onChange={this.handleChange}
                          onKeyDown={this.onKeyDown}
                          onBlur={() => this.onBlurHandle('contactPhoneNumber')}
                          label={this.l10n('CARDS_ORDER_LABEL_PHONE')}
                          format={this._phoneFormat}
                          stringify={this._phoneFormat}
                          defaultValue="+38 (0"
                          placeholder="+380 (66) 12 12 123"
                          floating={false}
                          className={`w-wide ${contactPhoneNumber.errors.length &&
                          !contactPhoneNumber.firstInput ? 'err-field' : ''}`}
                        />
                        <div className={`error-message ${this.state.sendOTPerrorMessage
                          ? 'active'
                          : ''
                        }`}
                        >
                          {this.state.sendOTPerrorMessage}
                        </div>
                        <div className={`error-message ${contactPhoneNumber.errors.length && !contactPhoneNumber.firstInput
                          ? 'active'
                          : ''
                          }`}
                        >
                          <div>{this.l10n(contactPhoneNumber.errors.join('.'))}</div>
                        </div>
                      </Control>
                    </div>
                    <div className="button-wrapper">
                      <button className="button button-send-form button-send-form-quick_cash-tel"
                              onClick={this.sendForm}
                              disabled={!model.canSubmit}>
                        {this.l10n('SEND_APPLICATION')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
        ),
      checkOTP = (<React.Fragment>
          <div className="left-side">
            <div className="left-side">
              <div className="title">{this.l10n('QUICK_CASH_WANT_TO_ORDER')}</div>
              <div className="sub-title">{this.l10n('QUICK_CASH_WANT_TO_ORDER_SUBTITLE')}</div>
              {loanSum && loanTerm && (
                <React.Fragment>
                  <div className="terms">{this.l10n('QUICK_CASH_WANT_TO_ORDER_SUM')}<div className="numbers">{loanSum.toLocaleString('RU-ru') + ' ' + this.l10n('UAH_ICON')}</div> </div>
                  <div className="terms">{this.l10n('QUICK_CASH_WANT_TO_ORDER_TERM')}<div className="numbers">{loanTerm} {this.l10n(termsData[loanTerm])}</div></div>
                </React.Fragment>
              )}
              <div className="card-order" style={(!loanSum && !loanTerm) ? { marginTop: '0px' } : {}}>
                <div className="order-wrapper green-card">
                  <Control>
                    <Input
                      name="passwordOTP"
                      value={passwordOTP.value}
                      onChange={this.handleChange}
                      onBlur={() => this.onBlurHandle('passwordOTP')}
                      label={this.l10n('GOOD_DEEDS_INPUT_LABEL_2')}
                      format={model._otpFormat}
                      stringify={model._otpFormat}
                      placeholder="___"
                      floating={false}
                      className={`w-wide otp ${contactPhoneNumber.errors.length &&
                      !contactPhoneNumber.firstInput ? 'err-field' : ''}`}
                    />
                    <div className={`error-message otp ${this.state.errorMessage
                      ? 'active'
                      : ''
                    }`}
                    >
                      {this.state.errorMessage}
                    </div>
                    <div className='repeateOTPpass'><span>{this.l10n('GOOD_DEEDS_INPUT_REPEATE_TEXT')}</span><button disabled={!repeatOTP} className='link' onClick={() => this.sendForm}>{this.l10n('GOOD_DEEDS_INPUT_REPEATE_TEXT_2')}</button>{" — "}<CountdownTimer/></div>
                  </Control>
                </div>
                <div className="button-wrapper">
                  <button className="button button-send-form button-send-form-quick_cash-code"
                          onClick={this.sendOTP}
                          disabled={!model.canSubmit}>
                    {this.l10n('SEND_APPLICATION')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      ),
        success = (
            <React.Fragment>
                <div className="result-wrapper">
                    <img className="success_icon" src={success_icon} alt="success_icon"/>
                    <h2>{this.l10n('QUICK_CASH_RESULT_ORDER_TITLE')}</h2>
                    <h3>{this.l10n('QUICK_CASH_RESULT_ORDER_SUBTITLE')}</h3>
                    <button className="btn-transparent">
                      {this.l10n('QUICK_CASH_RESULT_ORDER_BTN_GO_BACK')}
                    </button>
                </div>
            </React.Fragment>
        ),
        error = (
            <div className="error-body">
                <ErrorComponent type="form">
                    {this.l10n('GREEN_CARD_ORDER_ERROR_TEXT')}
                </ErrorComponent>
            </div>
        ),
        screens = {
            form,
            success,
            error,
          checkOTP
        },
      isSuccessState = this.state.activeScreen === 'success',
      isFormState = this.state.activeScreen === 'form';
    return (
        <div className="form-wrapper" onClick={this.closeModal}>
            <div className={`form-container card-order-wrapper ${!isFormState ? this.state.activeScreen : ''}-wrapper`} >
              {isSuccessState ? '' : <div className="close-button" />}
              {screens[this.state.activeScreen]}
            </div>
        </div>
    )
}
